(function () {
  function initPhoneModelFilters() {
    const details = document.querySelectorAll('.mobile-facets__details');

    details.forEach(function (detail) {
      const summary = detail.querySelector('summary');

      if (!summary) return;

      const title = summary.textContent.trim().toLowerCase();

      // Only modify the Phone model filter
      if (!title.includes('phone model')) return;

      const list = detail.querySelector('.mobile-facets__list');

      if (!list) return;

      // If the hierarchy already exists, don't build it again
      if (list.querySelector('.phone-filter-brand')) return;

      const originalItems = Array.from(
        list.querySelectorAll(':scope > li')
      );

      // Find the actual Shopify phone-model filter items
      const models = originalItems
        .map(function (item) {
          const input = item.querySelector(
            'input[name^="filter.v.option."]'
          );

          const label = item.querySelector(
            '.facet-checkbox__text-label'
          );

          if (!input || !label) return null;

          return {
            item: item,
            label: label.textContent.trim()
          };
        })
        .filter(Boolean);

      if (!models.length) return;

      buildHierarchy(list, models);
    });
  }

  function buildHierarchy(list, models) {
    models.forEach(function (model) {
      model.item.remove();
    });

    const brands = {};

    models.forEach(function (model) {
      const info = getModelInfo(model.label);

      if (!brands[info.brand]) {
        brands[info.brand] = createBrandGroup(info.brand);
      }

      addFamily(
        brands[info.brand].models,
        model,
        info.family
      );
    });

    const brandOrder = [
      'Apple',
      'Samsung',
      'Google',
      'Other'
    ];

    brandOrder.forEach(function (brand) {
      if (
        brands[brand] &&
        brands[brand].models.children.length > 0
      ) {
        list.appendChild(brands[brand].element);
      }
    });
  }

  function getModelInfo(label) {
    const value = label.trim();

    // APPLE
    if (/^iPhone/i.test(value)) {
      let family = value;

      const numericMatch = value.match(
        /^iPhone\s+(\d+)/i
      );

      if (numericMatch) {
        family = 'iPhone ' + numericMatch[1];
      }

      // iPhone X / XR / XS / XS Max
      if (/^iPhone X/i.test(value)) {
        if (
          /^iPhone X$/i.test(value) ||
          /^iPhone XR$/i.test(value) ||
          /^iPhone XS/i.test(value)
        ) {
          family = 'iPhone X';
        }
      }

      return {
        brand: 'Apple',
        family: family
      };
    }

    // SAMSUNG
    if (/^Samsung Galaxy/i.test(value)) {
      const match = value.match(
        /^Samsung Galaxy\s+([A-Za-z]+\s*\d+)/i
      );

      if (match) {
        return {
          brand: 'Samsung',
          family: 'Samsung Galaxy ' + match[1]
        };
      }

      return {
        brand: 'Samsung',
        family: value
      };
    }

    // GOOGLE
    if (/^Google Pixel/i.test(value)) {
      const match = value.match(
        /^Google Pixel\s+(\d+[A-Za-z]*)/i
      );

      if (match) {
        return {
          brand: 'Google',
          family: 'Google Pixel ' + match[1]
        };
      }

      return {
        brand: 'Google',
        family: value
      };
    }

    return {
      brand: 'Other',
      family: value
    };
  }

  function createBrandGroup(name) {
    const element = document.createElement('li');

    element.className = 'phone-filter-brand';

    const button = document.createElement('button');

    button.type = 'button';
    button.className = 'phone-filter-brand__button';

    button.setAttribute(
      'aria-expanded',
      'false'
    );

    button.innerHTML =
      '<span>' +
      name +
      '</span>' +
      '<span class="phone-filter-chevron">›</span>';

    const models = document.createElement('ul');

    models.className =
      'phone-filter-brand__models';

    models.hidden = true;

    button.addEventListener('click', function () {
      const isOpen =
        button.getAttribute('aria-expanded') === 'true';

      button.setAttribute(
        'aria-expanded',
        isOpen ? 'false' : 'true'
      );

      models.hidden = isOpen;

      const chevron =
        button.querySelector(
          '.phone-filter-chevron'
        );

      if (chevron) {
        chevron.textContent =
          isOpen ? '›' : '⌄';
      }
    });

    element.appendChild(button);
    element.appendChild(models);

    return {
      element: element,
      models: models
    };
  }

  function addFamily(
    container,
    model,
    familyName
  ) {
    let familyElement =
      Array.from(container.children).find(
        function (element) {
          return (
            element.dataset.family ===
            familyName
          );
        }
      );

    if (!familyElement) {
      familyElement =
        document.createElement('li');

      familyElement.className =
        'phone-filter-family';

      familyElement.dataset.family =
        familyName;

      const button =
        document.createElement('button');

      button.type = 'button';

      button.className =
        'phone-filter-family__button';

      button.setAttribute(
        'aria-expanded',
        'false'
      );

      button.innerHTML =
        '<span>' +
        familyName +
        '</span>' +
        '<span class="phone-filter-chevron">›</span>';

      const variants =
        document.createElement('ul');

      variants.className =
        'phone-filter-family__variants';

      variants.hidden = true;

      button.addEventListener(
        'click',
        function () {
          const isOpen =
            button.getAttribute(
              'aria-expanded'
            ) === 'true';

          button.setAttribute(
            'aria-expanded',
            isOpen ? 'false' : 'true'
          );

          variants.hidden = isOpen;

          const chevron =
            button.querySelector(
              '.phone-filter-chevron'
            );

          if (chevron) {
            chevron.textContent =
              isOpen ? '›' : '⌄';
          }
        }
      );

      familyElement.appendChild(button);
      familyElement.appendChild(variants);

      container.appendChild(
        familyElement
      );
    }

    const variants =
      familyElement.querySelector(
        '.phone-filter-family__variants'
      );

    variants.appendChild(model.item);
  }

  // Initial page load
  document.addEventListener(
    'DOMContentLoaded',
    function () {
      initPhoneModelFilters();
    }
  );

  // Shopify replaces filter HTML through AJAX.
  // Watch for those changes and rebuild the hierarchy.
  let timeout;

  const observer =
    new MutationObserver(function () {
      clearTimeout(timeout);

      timeout = setTimeout(
        function () {
          initPhoneModelFilters();
        },
        100
      );
    });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

/* =========================================
   SHOP BY PHONE MODEL - DESKTOP MENU
   ========================================= */

(function () {

  const phoneModels = [
    // Apple
    'iPhone 8',
    'iPhone 8 Plus',
    'iPhone 11',
    'iPhone 11 Pro',
    'iPhone 11 Pro Max',
    'iPhone 12',
    'iPhone 12 Mini',
    'iPhone 12 Pro',
    'iPhone 12 Pro Max',
    'iPhone 13',
    'iPhone 13 Mini',
    'iPhone 13 Pro',
    'iPhone 13 Pro Max',
    'iPhone 14',
    'iPhone 14 Plus',
    'iPhone 14 Pro',
    'iPhone 14 Pro Max',
    'iPhone 15',
    'iPhone 15 Plus',
    'iPhone 15 Pro',
    'iPhone 15 Pro Max',
    'iPhone 16',
    'iPhone 16 Plus',
    'iPhone 16 Pro',
    'iPhone 16 Pro Max',
    'iPhone 17',
    'iPhone 17 Air',
    'iPhone 17 Pro',
    'iPhone 17 Pro Max',
    'iPhone 18 Pro',
    'iPhone 18 Pro Max',
    'iPhone X',
    'iPhone XR',
    'iPhone XS',
    'iPhone XS MAX',

    // Samsung
    'Samsung Galaxy S20',
    'Samsung Galaxy S20 FE',
    'Samsung Galaxy S20 Plus',
    'Samsung Galaxy S20 Ultra',
    'Samsung Galaxy S21',
    'Samsung Galaxy S21 FE',
    'Samsung Galaxy S21 Plus',
    'Samsung Galaxy S21 Ultra',
    'Samsung Galaxy S22',
    'Samsung Galaxy S22 Plus',
    'Samsung Galaxy S22 Ultra',
    'Samsung Galaxy S23',
    'Samsung Galaxy S23 Plus',
    'Samsung Galaxy S23 Ultra',
    'Samsung Galaxy S24',
    'Samsung Galaxy S24 Plus',
    'Samsung Galaxy S24 Ultra',
    'Samsung Galaxy S25',
    'Samsung Galaxy S25 Plus',
    'Samsung Galaxy S25 Ultra',
    'Samsung Galaxy S26',
    'Samsung Galaxy S26 Plus',
    'Samsung Galaxy S26 Ultra',

    // Google
    'Google Pixel 5 5G',
    'Google Pixel 6',
    'Google Pixel 6 Pro',
    'Google Pixel 7',
    'Google Pixel 8',
    'Google Pixel 8 Pro',
    'Google Pixel 9',
    'Google Pixel 9 Pro',
    'Google Pixel 9 Pro XL'
  ];


  /*
   * Get brand + phone family
   */
  function getModelInfo(model) {

    const value = model.trim();

    // Apple
    if (/^iPhone/i.test(value)) {

      let family = value;

      const numericMatch =
        value.match(/^iPhone\s+(\d+)/i);

      if (numericMatch) {
        family = 'iPhone ' + numericMatch[1];
      }

      // iPhone X / XR / XS / XS MAX
      if (/^iPhone X/i.test(value)) {
        family = 'iPhone X';
      }

      return {
        brand: 'Apple',
        family: family
      };
    }


    // Samsung
    if (/^Samsung Galaxy/i.test(value)) {

      const match =
        value.match(
          /^Samsung Galaxy\s+([A-Za-z]+\s*\d+)/i
        );

      if (match) {
        return {
          brand: 'Samsung',
          family:
            'Samsung Galaxy ' + match[1]
        };
      }

      return {
        brand: 'Samsung',
        family: value
      };
    }


    // Google
    if (/^Google Pixel/i.test(value)) {

      const match =
        value.match(
          /^Google Pixel\s+(\d+[A-Za-z]*)/i
        );

      if (match) {
        return {
          brand: 'Google',
          family:
            'Google Pixel ' + match[1]
        };
      }

      return {
        brand: 'Google',
        family: value
      };
    }


    return {
      brand: 'Other',
      family: value
    };
  }


  /*
   * Create filtered product URL
   */
  function phoneUrl(model) {

    return (
      '/collections/all-products' +
      '?filter.v.option.size=' +
      encodeURIComponent(model) +
      '&sort_by=best-selling'
    );
  }


  /*
   * Create a brand section
   */
  function createBrand(brandName) {

    const brand =
      document.createElement('li');

    brand.className =
      'shop-phone-brand';


    const button =
      document.createElement('button');

    button.type = 'button';

    button.className =
      'shop-phone-brand-button';

    button.setAttribute(
      'aria-expanded',
      'false'
    );


    button.innerHTML =
      '<span>' +
      brandName +
      '</span>' +
      '<span class="shop-phone-arrow">›</span>';


    const content =
      document.createElement('div');

    content.className =
      'shop-phone-brand-content';

    content.hidden = true;


    button.addEventListener(
      'click',
      function (event) {

        event.preventDefault();
        event.stopPropagation();

        const isOpen =
          button.getAttribute(
            'aria-expanded'
          ) === 'true';


        button.setAttribute(
          'aria-expanded',
          isOpen ? 'false' : 'true'
        );


        content.hidden = isOpen;


        const arrow =
          button.querySelector(
            '.shop-phone-arrow'
          );


        if (arrow) {
          arrow.textContent =
            isOpen ? '›' : '⌄';
        }
      }
    );


    brand.appendChild(button);
    brand.appendChild(content);

    return {
      element: brand,
      content: content
    };
  }


  /*
   * Add a phone model to its family
   */
  function addFamily(
    container,
    familyName,
    model
  ) {

    let family =
      Array.from(
        container.children
      ).find(function (item) {

        return (
          item.dataset.family ===
          familyName
        );

      });


    if (!family) {

      family =
        document.createElement('div');

      family.className =
        'shop-phone-family';

      family.dataset.family =
        familyName;


      const button =
        document.createElement('button');

      button.type = 'button';

      button.className =
        'shop-phone-family-button';

      button.setAttribute(
        'aria-expanded',
        'false'
      );


      button.innerHTML =
        '<span>' +
        familyName +
        '</span>' +
        '<span class="shop-phone-arrow">›</span>';


      const content =
        document.createElement('div');

      content.className =
        'shop-phone-family-content';

      content.hidden = true;


      button.addEventListener(
        'click',
        function (event) {

          event.preventDefault();
          event.stopPropagation();

          const isOpen =
            button.getAttribute(
              'aria-expanded'
            ) === 'true';


          button.setAttribute(
            'aria-expanded',
            isOpen ? 'false' : 'true'
          );


          content.hidden = isOpen;


          const arrow =
            button.querySelector(
              '.shop-phone-arrow'
            );


          if (arrow) {
            arrow.textContent =
              isOpen ? '›' : '⌄';
          }
        }
      );


      family.appendChild(button);
      family.appendChild(content);

      container.appendChild(family);
    }


    const link =
      document.createElement('a');

    link.className =
      'shop-phone-model-link';

    link.href =
      phoneUrl(model);

    link.textContent =
      model;


    family
      .querySelector(
        '.shop-phone-family-content'
      )
      .appendChild(link);
  }


  /*
   * Build the complete desktop menu
   */
  function createMenu() {

    const menu =
      document.createElement('div');

    menu.className =
      'shop-phone-custom-menu';


    const brands = {};


    phoneModels.forEach(
      function (model) {

        const info =
          getModelInfo(model);


        if (!brands[info.brand]) {

          brands[info.brand] =
            createBrand(info.brand);
        }


        addFamily(
          brands[info.brand].content,
          info.family,
          model
        );

      }
    );


    const brandOrder = [
      'Apple',
      'Samsung',
      'Google',
      'Other'
    ];


    brandOrder.forEach(
      function (brandName) {

        if (brands[brandName]) {

          menu.appendChild(
            brands[brandName].element
          );
        }

      }
    );


    return menu;
  }


  /*
   * Initialize desktop Shop by Phone Model
   */
  function initShopPhoneModelMenu() {

    const shopLink =
      document.querySelector(
        '#HeaderMenu-shop-by-phone-model'
      );


    if (!shopLink) {
      return;
    }


    const parent =
      shopLink.closest('li');


    if (!parent) {
      return;
    }


    /*
     * Add the CSS class used by the
     * desktop dropdown.
     */
    parent.classList.add(
      'shop-phone-menu-parent'
    );


    /*
     * Create the custom menu once.
     */
    let customMenu =
      parent.querySelector(
        '.shop-phone-custom-menu'
      );


    if (!customMenu) {

      customMenu =
        createMenu();

      parent.appendChild(
        customMenu
      );
    }


    /*
     * Attach the click handler once.
     */
    if (
      shopLink.dataset.phoneMenuReady ===
      'true'
    ) {
      return;
    }


    shopLink.dataset.phoneMenuReady =
      'true';


    /*
     * Capture the click before the
     * normal homepage link can run.
     */
    shopLink.addEventListener(
      'click',
      function (event) {

        event.preventDefault();
        event.stopImmediatePropagation();


        parent.classList.toggle(
          'shop-phone-menu-open'
        );

      },
      true
    );
  }


  /*
   * Initial load
   */
  document.addEventListener(
    'DOMContentLoaded',
    function () {

      initShopPhoneModelMenu();

    }
  );


  /*
   * Watch for Shopify/theme DOM changes
   */
  let menuTimeout;


  const menuObserver =
    new MutationObserver(
      function () {

        clearTimeout(
          menuTimeout
        );


        menuTimeout =
          setTimeout(
            function () {

              initShopPhoneModelMenu();

            },
            100
          );

      }
    );


  menuObserver.observe(
    document.body,
    {
      childList: true,
      subtree: true
    }
  );

})();